import React, {
  Component,
  RefObject,
} from 'react';
import {
  withTranslation,
  WithTranslation,
} from 'react-i18next';
import {
  inject,
  observer,
} from 'mobx-react';
import DropdownWithCustomValue from '../../../components/Inputs/DropdownWithCustomValue';
import HaulerStore from '../../../stores/hauler-store';
import { Hauler } from '../../../../types/api/Hauler';

interface HaulerInputProps extends WithTranslation {
  value: string;
  onChange: (value: string) => void;
  haulerStore?: HaulerStore;
}

@inject('haulerStore')
@observer
class HaulerInput extends Component<HaulerInputProps> {
  anchor: RefObject<HTMLDivElement | null>;

  constructor(props: HaulerInputProps) {
    super(props);
    this.anchor = React.createRef();
  }

  render() {
    const { value, onChange, haulerStore, t } = this.props;
    const {
      haulers = [],
    } = haulerStore || {};

    const options = haulers.map((hauler: Hauler) => ({
      value: `${hauler.code} - ${hauler.name}`,
      label: `${hauler.code} - ${hauler.name}`,
    }));

    return (
      <DropdownWithCustomValue
        label={t('Hauler')}
        placeholder={t('Enter custom hauler')}
        value={value}
        onChange={onChange}
        options={options}
      />
    );
  }
}

export default withTranslation()(HaulerInput);
